// Google Analytics 4 setup. No-ops outside production or when VITE_GA_MEASUREMENT_ID is unset (e.g. local dev).
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as
  | string
  | undefined;

export function initAnalytics() {
  console.info(
    "init google analytics",
    import.meta.env.VITE_MODE !== "production" || !measurementId,
    import.meta.env.VITE_MODE !== "production",
    measurementId
  );
  if (import.meta.env.VITE_MODE !== "production" || !measurementId) return;
  console.info("init google analytics");

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Route changes are tracked manually via router.afterEach, so disable the automatic pageview.
  window.gtag("config", measurementId, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.addEventListener(
    "error",
    () => {
      console.error("[analytics] Failed to load Google Analytics");
    },
    { once: true }
  );
  document.head.appendChild(script);
}

export function trackPageView(path: string, title?: string) {
  if (import.meta.env.VITE_MODE !== "production" || !measurementId) return;
  window.gtag?.("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
    send_to: measurementId,
  });
}
